var map = {
	"./highlight/JetX.png": 28568,
	"./highlight/aviator.png": 87389,
	"./highlight/comet.png": 10059,
	"./highlight/default.png": 59696,
	"./highlight/liginare.png": 66466,
	"./highlight/virtuals.png": 52095,
	"./img/PayBill.png": 17283,
	"./img/Surebet.logo.F.png": 27779,
	"./img/Virtual-side-Banner.png": 95968,
	"./img/advertgames/game1.png": 32875,
	"./img/advertgames/game10.png": 23587,
	"./img/advertgames/game11.png": 59482,
	"./img/advertgames/game12.png": 80593,
	"./img/advertgames/game2.png": 67472,
	"./img/advertgames/game3.png": 83225,
	"./img/advertgames/game4.png": 94598,
	"./img/advertgames/game5.png": 63343,
	"./img/advertgames/game6.png": 40884,
	"./img/advertgames/game7.png": 62013,
	"./img/advertgames/game8.png": 85418,
	"./img/advertgames/game9.png": 36179,
	"./img/airtelmoney.png": 16247,
	"./img/banner/App.png": 13322,
	"./img/banner/Breakfast.png": 67208,
	"./img/banner/CashBack.png": 43031,
	"./img/banner/Casino.png": 13070,
	"./img/banner/EPL.png": 59442,
	"./img/banner/Freebet.png": 93588,
	"./img/banner/Live-Betting.png": 37347,
	"./img/banner/Multibet.png": 45535,
	"./img/banner/Sharebet.png": 15501,
	"./img/banner/Tick.png": 33876,
	"./img/banner/Welcome-Bonus.png": 721,
	"./img/banner/carousel/CashBack.png": 14038,
	"./img/banner/carousel/Live-Betting.png": 60446,
	"./img/banner/carousel/Sharebet.png": 48468,
	"./img/banner/carousel/Tick.png": 24561,
	"./img/banner/carousel/Welcome-Bonus.png": 6782,
	"./img/banner/carousel/app.png": 80813,
	"./img/banner/carousel/breakfast.png": 28363,
	"./img/banner/carousel/casino.png": 65759,
	"./img/banner/carousel/jackpot.png": 1402,
	"./img/banner/carousel/moses-epl.png": 44113,
	"./img/banner/carousel/multibet.png": 4070,
	"./img/banner/jackpot.png": 12437,
	"./img/banner/jackpots/DailyJackpot.png": 56060,
	"./img/banner/market.png": 97635,
	"./img/banner/print-matches/Footer.png": 38346,
	"./img/banner/print-matches/Header.png": 98084,
	"./img/banner/products/CashBack.png": 99436,
	"./img/banner/products/Deposit-Bonus.png": 41634,
	"./img/banner/products/JackPot.png": 14992,
	"./img/banner/products/Live-Betting.png": 56392,
	"./img/banner/products/Mshipi-Bonus.png": 63102,
	"./img/banner/products/Welcome-Bonus.png": 41432,
	"./img/betrader/test-game-details.png": 57336,
	"./img/bpl.png": 23312,
	"./img/brazil.png": 50718,
	"./img/bundesliga.png": 59488,
	"./img/casino/background1.png": 45881,
	"./img/casino/bg-black.png": 35305,
	"./img/casino/bg-pink.png": 40878,
	"./img/casino/bg-yellow.png": 99490,
	"./img/casino/box.png": 94587,
	"./img/casino/carousel/10.png": 16358,
	"./img/casino/carousel/13.png": 13917,
	"./img/casino/carousel/2.png": 70839,
	"./img/casino/carousel/3.png": 27822,
	"./img/casino/carousel/4.png": 63937,
	"./img/casino/carousel/6.png": 70163,
	"./img/casino/carousel/9.png": 27892,
	"./img/casino/carousel/Tick.png": 36226,
	"./img/casino/carousel/intro.png": 49139,
	"./img/casino/closedbox.png": 60287,
	"./img/casino/default.png": 44955,
	"./img/casino/fsurebox/closedbox.png": 24364,
	"./img/casino/head.png": 92988,
	"./img/casino/icons/fazi.png": 37987,
	"./img/casino/icons/split the pot.png": 64323,
	"./img/casino/tail.png": 19500,
	"./img/casino/vault.png": 17224,
	"./img/casino/wo2.png": 95812,
	"./img/casino/won.png": 94616,
	"./img/casino/won3.png": 4929,
	"./img/clock.png": 67612,
	"./img/colorsvgicons/default.png": 70049,
	"./img/flags-1-1/hipo.png": 60322,
	"./img/flags-1-1/sure.png": 4035,
	"./img/france.png": 27205,
	"./img/general-website/google-play-badge.png": 6465,
	"./img/germany.png": 17129,
	"./img/header-images/americanfootball.png": 46128,
	"./img/header-images/aussie.png": 60651,
	"./img/header-images/aviator.png": 37487,
	"./img/header-images/casino-direct.png": 5928,
	"./img/header-images/crash-games.png": 10062,
	"./img/header-images/darts.png": 55107,
	"./img/header-images/default.png": 24978,
	"./img/header-images/evolution-logo-2.png": 22385,
	"./img/header-images/home.png": 35384,
	"./img/header-images/liginare.png": 81928,
	"./img/header-images/soccer.png": 63088,
	"./img/header-images/sure-live.png": 12739,
	"./img/header-images/sureturbo.png": 24704,
	"./img/header-images/volleyball.png": 82401,
	"./img/hipo.png": 56682,
	"./img/iceland.png": 42036,
	"./img/italy.png": 64319,
	"./img/laliga.png": 1983,
	"./img/logo.png": 65549,
	"./img/logo2 (2).png": 53916,
	"./img/logo2.png": 93131,
	"./img/mobile/APPDownload.png": 17702,
	"./img/mpesa-1.png": 11396,
	"./img/mpesa-3.png": 69718,
	"./img/mpesa.png": 87806,
	"./img/norway.png": 33566,
	"./img/padlock.png": 96348,
	"./img/rugby-mobile.png": 61804,
	"./img/rugby.png": 26295,
	"./img/seriea.png": 86457,
	"./img/spain.png": 86209,
	"./img/sure.png": 50363,
	"./img/svgicons/default.png": 29765,
	"./img/todays.png": 66046,
	"./img/ucl.png": 74566,
	"./img/uefa.png": 3769,
	"./svg/hipo.png": 94327,
	"./svg/sure.png": 51354,
	"./team-jersies/away-default.png": 73350,
	"./team-jersies/home-default.png": 93749
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72014;